module.exports = __webpack_public_path__ + "alarm.mp3?ee232f35cb33fc9496b896aac57bf55b";


//////////////////
// WEBPACK FOOTER
// ./src/kits/1/sounds/alarm.mp3
// module id = 477
// module chunks = 0